import * as React from 'react';
/**
 * @ignore - internal component.
 */

var TableContext = /*#__PURE__*/React.createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

export default TableContext;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Table/TableContext.js
// module id = 814
// module chunks = 121